export const checkSafeOpener = () => {
  if (window.opener) {
    try {
      // Accessing window.opener.origin throws a SecurityError for cross-origin openers
      // due to the Same-Origin Policy. If a non-HubSpot domain opened this page via
      // window.open(), this will throw and we nullify window.opener in the catch block,
      // severing the browsing context link and preventing the opener from navigating our window.
      void window.opener.origin;
    } catch (error) {
      window.opener = null;
    }
  }
};